import { useLinkProps } from '@react-navigation/native';
import type { FC } from 'react';
import type { SurfaceProps } from 'react-native-paper';
import { Surface, TouchableRipple } from 'react-native-paper';

import type {
  NavigationItemProps,
  AppRoute
} from '@/navigation/types/navigation';

// See: https://reactnavigation.org/docs/link

type Props = NavigationItemProps & SurfaceProps;

export const NavigationSurface: FC<Props> = ({
  screen,
  params,
  action,
  href,
  children,
  ...rest
}) => {
  const linkProps = useLinkProps<AppRoute>({
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    screen,
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    params,
    action,
    href
  });

  return (
    <Surface {...rest}>
      <TouchableRipple {...linkProps}>{children}</TouchableRipple>
    </Surface>
  );
};
